import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-error-dialog',
  standalone: false,
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent {
  dialogTitle: string = 'Application Error';
  dialogMessage: string;

  constructor(private modal: NgbActiveModal) { }

  close() {
    this.modal.close();
  }
}
